<h1 mat-dialog-title>Netzwerk l&ouml;schen?</h1>
<div mat-dialog-content>
	M&ouml;chten Sie das logische Netzwerk wirklich l&ouml;schen?
</div>
<mat-dialog-actions>
	<button mat-raised-button  title="Abbrechen" (click)="cancelDeleteNetworkClick_dialog()">Abbrechen</button>
	<button mat-raised-button title="Loeschen" (click)="deleteNetworkClick_dialog()">L&ouml;schen</button>
</mat-dialog-actions>